<template>
  <div v-loading="loading">
    <page-header title="Estimates" breadcrumb="Billings & Payment > Estimates" />

    <div class="card table-header mt-4">
      <div class="flex justify-between">
        <div class="group-options-select">
          <div class="flex">
            <div class="mr-2 shadow-table p-2 filter">
              <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
            </div>
            <div class="table__search-input-wrapper">
              <span class="pr-2 opacity-50"><search-icon /> </span>
              <input
                type="text"
                class="table__search-input"
                placeholder="Search..."
                v-model="queryString"
              />
              <img src="@/assets/images/icons/search.svg" alt="search icon" />
            </div>
          </div>
        </div>

        <div class="flex gap-4">
          <router-link :to="{name: 'NewEstimate'}">
            <base-button text="New Estimate" />
          </router-link>
        </div>
      </div>
    </div>

    <div class="responsive-table" id="table-wrapper">
      <h3 class="fond-bold mt-8 mb-4">Estimates Register</h3>
      <table class="custom-table responsive-table border-collapse">
        <thead>
          <tr class="shadow-table rounded-lg">
            <th class="checkbox">
                <base-checkbox />
            </th>
            <th>QUOTE NUMBER</th>
            <th>DATE</th>
            <th>CUSTOMER</th>
            <th>TOTAL WEIGHT (KG)</th> 
            <th>SHIPPING COST</th>
            <th>STATUS</th>
            <th tabindex="-1">
              <span class="cursor-pointer">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.7">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51"
                    />
                  </g></svg
              ></span>
            </th>
          </tr>
        </thead>
        <tbody v-if="!loading">
          <tr
            v-for="group in filteredGroups"
            :key="group.id"
            class="shadow-table rounded-lg"
          >
            <td>
              <base-checkbox />
            </td>
            <td>{{ group.name }}</td>
            <td>{{ group.description }}</td>
            <td>
              {{
                group.superAdmin
                  ? group.superAdmin.fname + " " + group.superAdmin.lname
                  : "-"
              }}
            </td>
            <td>{{ group.membersCount }}</td>
            <!-- <td v-if="group.groupincidents">{{ group.groupincidents.length }}</td>
            <td v-else>-</td> -->
            <td>{{ group.createdAt | formatDate }}</td>
            <td
              tabindex="-1"
              @blur="selectedRowId = null"
              class="table__action-btn cursor-pointer"
            >
              <span @click="showActionOptions(group.id)">
                <vertical-ellipsis />
              </span>

              <div class="actions" v-if="selectedRowId == group.id">
                <div>
                  <p>Actions</p>
                  <hr />
                </div>
                <div
                  class="cursor-pointer hover:bg-gray-100"
                  @click="editIncident(group)"
                >
                  <span class="icon"><edit-icon /></span>
                  <span>Edit</span>
                </div>
                <div
                  class="cursor-pointer hover:bg-gray-100"
                  @click="viewIncident(group)"
                >
                  <span class="icon"><eye-icon /></span>
                  <span>View Details</span>
                </div>
                <div class="cursor-pointer hover:bg-gray-100" @click="viewTimeline(group)">
                  <span class="icon"><timeline-icon /></span>
                  <span>View Timeline</span>
                </div>
                <div class="cursor-pointer hover:bg-gray-100" @click="processTranload(group)">
                  <span class="icon"><vehicle-icon /></span>
                  <span>Process Transload</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!filteredGroups.length" class="flex flex-col items-center">
        <empty-incident-icon />

        <p class="text-center text-sm font-bold">No request data found!.</p>
      </div>
    </div>
    <pagination-control />
    
  </div>
</template>

<script>
import PaginationControl from "@/components/UI/NewPagination";
import PageHeader from "@/components/UI/NewPageHeader";


export default {
  name: "request-table",
  components: {
    PaginationControl,
    PageHeader
  },
  props: ["fetchGroups"],
  data() {
    return {
      selectedRowId: null,
      selectedOption: "functional",
      options: [
        { value: "functional", text: "Functional" },
        { value: "management", text: "Management" },
        { value: "projects", text: "Projects" },
      ],
      isDeactivateModal: false,
      groupTypes: ["Functional", "Management", "Projects"],
      groups: [],
      loading: true,
      selectedGroup: {},
      groupType: "Functional",
      queryString: "",
    };
  },
  computed: {
    filteredGroups() {
      return this.filterArray(this.groups, this.queryString);
      // return this.groups;
    },
  },
  mounted() {
    this.getAllIncidents();
  },
  watch: {
    groupType() {
      this.isGroupInLocalStorage(this.groupType);
      this.getAllGroups();
    },
  },
  methods: {
    async getAllIncidents() {
      try {
        let response = await this.$_getAllIncidents();
        console.log(response);
        this.loading = false;
        this.incidents = response.data.driverAssistanceRequests
        localStorage.setItem("incidents", JSON.stringify(this.incidents));
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    saveGroupToLocalStorage() {
      if (this.groupType == "Functional") {
        localStorage.setItem("functionalGroups", JSON.stringify(this.groups));
      } else if (this.groupType == "Management") {
        localStorage.setItem("managementGroups", JSON.stringify(this.groups));
      } else if (this.groupType == "Projects") {
        localStorage.setItem("projectsGroups", JSON.stringify(this.groups));
      }
    },
    isGroupInLocalStorage(groupType) {
      groupType = groupType.toLowerCase();
      groupType = groupType + "Groups";
      let group = JSON.parse(localStorage.getItem(groupType));
      if (group) {
        this.groups = group;
      } else {
        this.getAllGroups();
      }
    },
    viewSingleGroup(groupId) {
      localStorage.setItem("groupId", groupId);
      this.$router.push("/settings/incidents-and-groups/single-group");
    },
    
    changeGroupType(groupType) {
      this.groupType = groupType;
    },
    showDeactivateModal(group) {
      this.selectedGroup = group;
      this.isDeactivateModal = true;
    },
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    showDeleteModal(groupId) {
      this.$emit("show-delete-modal", ["Group", groupId]);
      this.resetSelectedRow();
    },
    showViewRoleModal() {
      this.$emit("show-view-role-modal");
      this.resetSelectedRow();
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
    editIncident(group) {
      localStorage.setItem("editedGroup", JSON.stringify(group));
      this.$router.push({ name: "editIncident" });
    },
    viewIncident(incident) {
      localStorage.setItem("editedIncident", JSON.stringify(incident));
      this.$router.push({ name: "IncidentDetails" });
    },
    viewTimeline(groupId) {
      localStorage.setItem("groupId", groupId);
      this.$router.push({ name: "IncidentShippmentTimeline" });
    },
    processTranload(incident) {
      localStorage.setItem("editedIncident", JSON.stringify(incident));
      this.$router.push({ name: "IncidentProcessTransload" });
    },
  },
};
</script>


<style lang="scss" scoped>
.status {
  background: #09b78a1a;
  color: #09b78a;
}
.status-transist {
  color: #fcc210;
  background: #fcc2101a;
}

tr:first-child td:first-child {
  border-top-left-radius: 10px;
}
tr:first-child td:last-child {
  border-top-right-radius: 10px;
}
tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}
tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}
.table__search-input-wrapper {
  background: #7b858f10;
  width: 20vw;
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
.actions {
  position: absolute;
  background: #ffffff;
  top: 3rem;
  right: 2rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 12rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;
  .icon {
    width: 2.5em;
  }
  span {
    padding-right: 0.25rem;
  }
  > div {
    padding: 0.75rem;
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}
</style>
